module.exports = __webpack_public_path__ + "static/media/acilis_logo.f07ee8bb.png";